import { useLayoutEffect } from "react";
import { useLocation } from 'react-router-dom'

// How long to keep looking for a #hash target while a lazy page is still loading.
const HASH_WAIT_MS = 3000;

const ScrollToTop = ({children}) => {
    const { pathname, hash } = useLocation();
    useLayoutEffect(() => {
      if (!hash) {
        document.documentElement.scrollTo(0, 0);
        return;
      }
      let frame;
      const start = Date.now();
      const scrollToHash = () => {
        const target = document.getElementById(decodeURIComponent(hash.slice(1)));
        if (target) {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        } else if (Date.now() - start < HASH_WAIT_MS) {
          frame = requestAnimationFrame(scrollToHash);
        }
      };
      scrollToHash();
      return () => cancelAnimationFrame(frame);
    }, [pathname, hash]);
    return children
};

export default ScrollToTop;
